import React from 'react';

/**
 * Shared Medicare FAQ accordion data for compare/results pages.
 * @param {'hmo'|'ppo'} planType - Western NY uses PPO; standard Medicare uses HMO
 */
export function getMedicareFaqs ({ planType = 'hmo' } = {}) {
  const pcpAnswer = planType === 'ppo' ?
    'Medicare Advantage PPO plans do not require you to name a PCP.' :
    'Medicare Advantage HMO plans require you to designate a PCP.';

  return [
    {
      index: 1,
      title: 'What is Medicare Advantage?',
      content: `Medicare plans take four forms. Part A (hospital coverage) and Part B (outpatient coverage) plans are offered by the federal government and are what most people think of as “original” Medicare. Part D (prescription coverage) plans were introduced to offset the cost of medications. Part C (Medicare Advantage) plans are offered by commercial insurers like CDPHP that combine all the benefits of Original Medicare Parts A and B, and often also include Part D, along other benefits like dental and vision, for a single monthly premium. `
    },
    {
      index: 2,
      title: 'Will I need a primary care physician (PCP)?',
      content: pcpAnswer
    },
    {
      index: 3,
      title: 'What will my prescription drugs cost?',
      content: (
        <div>
          <p>
            If you have prescription drug coverage, you can fill prescriptions at any in-network pharmacy you choose. But you may see significant savings by using a preferred retail location. Use our{' '}
            <a href='https://www.cdphp.com/medicare/drug-coverage' target='_blank' rel='noopener noreferrer'>online drug lookup tool</a>
            {' '}to see if your prescription drugs are covered.
          </p>
          <p>
            If you’d rather not visit the pharmacy, you can also sign up for automatic mail-order delivery. Enjoy convenient, reliable, and free standard delivery of medications.
          </p>
        </div>
      )
    },
    {
      index: 4,
      title: 'How do I confirm my doctors are in your network?',
      content: (
        <p>
          Thousands of doctors and most major hospitals in the CDPHP service area are included in our network. Our{' '}
          <a href='https://findadoc.cdphp.com' target='_blank' rel='noopener noreferrer'>Find a Doctor</a>
          {' '}search tool makes it easy to confirm that your preferred providers are all “in”.
        </p>
      )
    },
    {
      index: 5,
      title: 'Will I be covered when I’m traveling out of the area?',
      content: `Our Medicare Advantage HMO plans offer emergency coverage from any provider when you’re outside our service area or traveling internationally.`
    },
    {
      index: 6,
      title: 'How do I enroll?',
      content: `You can enroll in a Medicare Advantage plan during the annual open enrollment period, which runs from October 15 through December 7 each year. Or, you may have access to a special enrollment period due to events such as turning 65, loss of employer coverage, or a recent move.`
    }
  ];
}

export default getMedicareFaqs;
